import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  margin: 0 auto;

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 72px;
    align-items: center;
  }
`;

export const TextSection = styled(FlexColumn)`
  gap: 32px;

  ${QUERIES.laptopAndUp} {
    padding: 24px 0;
  }
`;

export const IconTextContainer = styled(FlexColumn)`
  margin-top: 24px;
  gap: 12px;

  svg {
    background: ${themeStyle.transparentBlack};
    padding: 8px;
    border-radius: ${themeStyle.radiusMedium};
  }
`;

export const IconText = styled(P2)`
  padding: 9px 10px;
  margin-left: 10px;
  color: ${themeStyle.varInkMain};
`;
